export const billingPages = {
  board: () => import('./pages/BillingPage'),
  setter: () => import('./pages/InvoiceSetterPage'),
};
